import type { ISwitchPackageStageData } from "app/components/PackageSwitcher/components/SwitchPackageStage/stageConfig";
import type { ISwitchPackageTrackingInformation } from "app/components/PackageSwitcher/types/switchPackageTracking.types";
import type { ISwitchPackageOptions } from "app/custom-hooks/switchPackage/useSwitchPackagePopup.types";

export const SwitchPackageStageName = {
    LOADING: "LOADING",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
    PAYMENT_FAILURE: "PAYMENT_FAILURE",
} as const;

export type SwitchPackageStageName = (typeof SwitchPackageStageName)[keyof typeof SwitchPackageStageName];

export interface IUseSubmitPackageChangeProps {
    packageToChange?: ISwitchPackageOptions;
    trackingInformation?: ISwitchPackageTrackingInformation;
}

export interface IUseSubmitPackageChangeAPI {
    switchPackageStageName: SwitchPackageStageName | null;
    isInProcessOfPackageSwitching: boolean;
    switchPackageStageData: ISwitchPackageStageData;
    shouldCloseModalOnEsc: boolean;
    handleSubmitButtonClick: () => void;
    onModalActionSuccess: () => void;
}
